/**
 * @desc 删除主要物料设置
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {
  /** 主键id */
  id: number;
}

export function request(params: Params): Promise<defs.StandardReturn<void>> {
  return defHttp.delete({
    url: '/web/setting/material/delete',

    params,
  });
}

export function mock(params: Params): Promise<defs.StandardReturn<void>> {
  return defHttp.delete({
    url: '/mock/web/setting/material/delete',

    params,
  });
}
